module.exports = __webpack_public_path__ + "components/modal-app-popup/static/edge-icon-39c9eb7181e8e96b99f95b45ca4b87f1.webp";